const KEY = "stx_cart_v1";

export const createCart = () => ({ items: [] });

export const loadCart = () => {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const saveCart = (cart) => {
    try {
        localStorage.setItem(KEY, JSON.stringify(cart));
    } catch {
        /* ignore */
    }
};
